import gql from 'graphql-tag';

export const HOME_ASSET_TOKEN_QUERY = gql`
  query HomeAssetToken {
    getAssetToken(input: { isMobile: false }) {
      assetToken
    }
  }
`;
